/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AutomaticValidationRequest
 */
export interface AutomaticValidationRequest {
    /**
     * 
     * @type {string}
     * @memberof AutomaticValidationRequest
     */
    workflowInstanceId: string;
    /**
     * 
     * @type {string}
     * @memberof AutomaticValidationRequest
     */
    lei: string;
    /**
     * 
     * @type {string}
     * @memberof AutomaticValidationRequest
     */
    domain: string;
}

/**
 * Check if a given object implements the AutomaticValidationRequest interface.
 */
export function instanceOfAutomaticValidationRequest(value: object): boolean {
    if (!('workflowInstanceId' in value)) return false;
    if (!('lei' in value)) return false;
    if (!('domain' in value)) return false;
    return true;
}

export function AutomaticValidationRequestFromJSON(json: any): AutomaticValidationRequest {
    return AutomaticValidationRequestFromJSONTyped(json, false);
}

export function AutomaticValidationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutomaticValidationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'workflowInstanceId': json['workflowInstanceId'],
        'lei': json['lei'],
        'domain': json['domain'],
    };
}

export function AutomaticValidationRequestToJSON(value?: AutomaticValidationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'workflowInstanceId': value['workflowInstanceId'],
        'lei': value['lei'],
        'domain': value['domain'],
    };
}

